(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
$(document).ready(function () {
  $('.js_nav-parent').click(function() {
    $(this).toggleClass('expanded');
    $(this).find('.js_nav-child').slideToggle(200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {
  $('.js_mobile-top-nav-item').click(function() {
    $('.js_mobile-top-nav-item').not(this).removeClass('expanded').next('.js_mobile-top-submenu').slideUp(200);
    $(this).toggleClass('expanded');
    $(this).next('.js_mobile-top-submenu').slideToggle(200);
    $('.js_mobile-nav-item').removeClass('expanded').next('.js_mobile-submenu').slideUp(200);
  });
  $('.js_mobile-nav-item').click(function() {
    $(this).toggleClass('expanded').next('.js_mobile-submenu').slideToggle(200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();
})();
